// import axios from 'axios'
import requests from '../utils/request'

// 我的活动
export const getMyActivelist = (data)=>{
    return requests({
        url:'/buyer/my/active/list',
        method:'get',
        params: data
    }) 
}
// 全部活动
export const getALLActivelist = ()=>{
    return requests({
        url:'/buyer/my/active/name/list',
        method:'get',
    }) 
}